import UnitTypes from '../../../constants/UnitTypes';
import MeshBasicTintAnimatedMaterial from '../materials/MeshBasicTintAnimatedMaterial';
import { ShaderChunk } from '../shaders/ShaderChunk';

const THREE = require('three');
// const MSDFShader = require('three-bmfont-text/shaders/msdf');

//
// Prepared materials storage:
// (e.g. preloaded matcaps)

// const materialsMap = new Map();

const createMeshBasicMaterial = (type, config) => {
    const variantsConfig = {
        default: {
            color: 0xffffff,
            transparent: false,
            side: THREE.FrontSide
        }
    };

    const { variant } = config;
    const defaults = variantsConfig[variant ?? type ?? 'default'];

    const params = { ...defaults, ...config };

    // Delete if have not yet
    delete params.type;

    const material = new THREE.MeshBasicMaterial(params);

    material.depthWrite = !params.transparent;

    return material;
};

const createDefaultMatcapMaterial = (config) => {
    const defaults = {
        color: 0xffffff,
        transparent: false,
        side: THREE.FrontSide
    };

    const params = { ...defaults, ...config };

    // Delete if have not yet
    delete params.type;

    return new THREE.MeshMatcapMaterial(params);
};

const createPreviewMaterial = (config) => {
    const defaults = {
        color: 0xffffff,
        transparent: true,
        side: THREE.FrontSide
    };

    const params = { ...defaults, ...config };

    // Delete if have not yet
    delete params.type;

    return new MeshBasicTintAnimatedMaterial(params);
};

/* const createTextMaterial = (config) => {
    const { color, atlas, alphaTest } = config;

    return new THREE.RawShaderMaterial(
        MSDFShader({
            map: atlas,
            color: new THREE.Color(color ?? 0x000000),
            side: THREE.DoubleSide,
            transparent: false,
            alphaTest,
            negate: false
        })
    );
}; */

// Fog Support materials
const createTextMaterial2 = (config, variant, uniforms = {}) => {
    const { color, atlas } = config;

    const fragmentShader = ShaderChunk.meshtext2_frag;
    const vertexShader = ShaderChunk.meshtext2_vert;

    return new THREE.ShaderMaterial({
        fragmentShader,
        vertexShader,
        side: THREE.DoubleSide,
        transparent: true,
        fog: true,
        uniforms: {
            uMap: new THREE.Uniform(atlas),
            uColor: new THREE.Uniform(new THREE.Color(color ?? 0x000000)),
            fogColor: { type: 'c', value: new THREE.Color(0x000000) },
            fogNear: { type: 'f', value: 50 },
            fogFar: { type: 'f', value: 80 },
            ...uniforms
        }
    });
};

// Fog and Wave animation Support material
const createTextMaterial3 = (config, uniforms = {}) => {
    const { color, atlas } = config;

    return new THREE.ShaderMaterial({
        fragmentShader: ShaderChunk.meshtextwave_frag,
        vertexShader: ShaderChunk.meshtextwave_vert,
        side: THREE.DoubleSide,
        transparent: true,
        fog: true,
        uniforms: {
            uMap: new THREE.Uniform(atlas),
            uColor: new THREE.Uniform(new THREE.Color(color ?? 0x000000)),
            fogColor: { type: 'c', value: new THREE.Color(0x000000) },
            fogNear: { type: 'f', value: 50 },
            fogFar: { type: 'f', value: 80 },
            time: { type: 'f', value: 0 },
            ...uniforms
        }
    });
};

// Fog, Wave animation and Shift progress Support material
/* const createTextMaterial4 = (config, uniforms = {}) => {
    const { color, atlas } = config;

    return new THREE.ShaderMaterial({
        fragmentShader: ShaderChunk.meshtextwaveshift_frag,
        vertexShader: ShaderChunk.meshtextwaveshift_vert,
        side: THREE.DoubleSide,
        transparent: true,
        fog: true,
        uniforms: {
            uMap: new THREE.Uniform(atlas),
            uColor: new THREE.Uniform(new THREE.Color(color ?? 0x000000)),
            uShiftAmp: { type: 'f', value: 500 },
            uShiftInfluence: { type: 'f', value: 0 },
            fogColor: { type: 'c', value: new THREE.Color(0x000000) },
            fogNear: { type: 'f', value: 50 },
            fogFar: { type: 'f', value: 80 },
            time: { type: 'f', value: 0 },
            ...uniforms
        }
    });
};

// Fog and Shift progress Support material
const createTextMaterial5 = (config, uniforms = {}) => {
    const { color, atlas } = config;

    return new THREE.ShaderMaterial({
        fragmentShader: ShaderChunk.meshtextshift_frag,
        vertexShader: ShaderChunk.meshtextshift_vert,
        side: THREE.DoubleSide,
        transparent: true,
        fog: true,
        uniforms: {
            uMap: new THREE.Uniform(atlas),
            uColor: new THREE.Uniform(new THREE.Color(color ?? 0x000000)),
            uShiftAmp: { type: 'f', value: 500 },
            uShiftInfluence: { type: 'f', value: 0 },
            fogColor: { type: 'c', value: new THREE.Color(0x000000) },
            fogNear: { type: 'f', value: 50 },
            fogFar: { type: 'f', value: 80 },
            ...uniforms
        }
    });
}; */

export const MaterialsFactory = {
    create(config, type) {
        // Default type is 'MeshBasicMaterial'
        // Add switch instructions to add options

        type = type ?? config.type;

        let material = null;

        switch (type) {
            case UnitTypes.PREVIEW:
                material = createPreviewMaterial(config);

                break;

            case 'textMaterial2':
                material = createTextMaterial2(config);

                break;

            case 'textWaveMaterial':
                material = createTextMaterial3(config);

                break;

            case 'matcap':
                material = createDefaultMatcapMaterial(config);

                break;

            default:
                material = createMeshBasicMaterial(type, config);

                break;
        }

        return material;
    }
};
